import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, debounceTime } from 'rxjs';

export enum SearchInputType {
  SearchBar = 'search-bar',
  FormElement = 'form-element',
  PopUp = 'pop-up',
}
@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
})
export class SearchInputComponent {
  @Input() styleType: SearchInputType = SearchInputType.SearchBar;
  @Input() searchValue: string = '';
  @Output() searchChanged = new EventEmitter<string>();
  searchInput = new BehaviorSubject('');

  search() {
    this.searchInput.next(this.searchValue);
    this.searchInput.pipe(debounceTime(1000)).subscribe((value: string) => {
      this.searchChanged.emit(value);
    });
  }
}
